import React from 'react';
import propTypes from 'prop-types';
import Layout, {
  LayoutHeader,
  LayoutBody
} from '../Layout';

import './style.css';

import * as tripHelper from '../../../../../helpers/trip';
import * as routeHelper from '../../../../../helpers/route';
import {FAILURE} from '../../../../../utils/status';


DaySummary.propTypes = {
  trip: propTypes.object.isRequired,
  route: propTypes.object,
  routeStatus: propTypes.string,
  day: propTypes.number.isRequired
};

export default function DaySummary(props) {
  let {trip, day, route, routeStatus} = props;

  let cities = tripHelper.getCitiesOfDayTrip(trip, day);
  let pic = cities && cities[0] && cities[0].pic.small_s;

  let distance = '--';
  let oils = '--';
  if (route && routeStatus !== FAILURE) {
    distance = routeHelper.caculateDistance(route);
    distance = routeHelper.formatDistance(distance);

    oils = routeHelper.caculateOils(route);
    oils = routeHelper.formatOils(oils);
  }

  let time = trip.start_time;
  if (time) {
    time += (day - 1) * 24 * 60 * 60;
  }

  return (
    <Layout className='day-summary'>
      <LayoutHeader className='header'>
        <div className='image' style={{
          backgroundImage: `url(${pic})`
        }} />
      </LayoutHeader>
      <LayoutBody className='body'>
        <h3>{cities && cities.map(function (city) {
          return city.cn_name;
        }).join('-')}</h3>

        {time ? (
          <div className='date'>
            <em>{tripHelper.formatTime2(time)}</em>
            <span className='cut-line'>|</span>
            <em>{tripHelper.formatTime3(time)}</em>
          </div>
        ) : null}

        <div className='drive-data'>
          <em>驾驶距离<b>{distance}公里</b></em>
          <span className='cut-line'>|</span>
          <em>预计耗油<b>{oils}升</b></em>
        </div>
      </LayoutBody>
    </Layout>
  );
}



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/DayTrip/DaySummary/index.js